import type { PrecacheEntry, SerwistGlobalConfig } from "serwist";
import { CacheableResponsePlugin, CacheFirst, ExpirationPlugin, NetworkFirst, Serwist, StaleWhileRevalidate } from "serwist";

declare global {
	interface WorkerGlobalScope extends SerwistGlobalConfig {
		__SW_MANIFEST: (PrecacheEntry | string)[] | undefined;
	}
}

declare const self: ServiceWorkerGlobalScope;

const serwist = new Serwist({
	precacheEntries: self.__SW_MANIFEST,
	skipWaiting: true,
	clientsClaim: true,
	navigationPreload: false,
	runtimeCaching: [
		{
			matcher: /^\/images\/map_tiles\/.*\.(jpg|jpeg)$/,
			handler: new CacheFirst({
				cacheName: "map-tiles-cache",
				plugins: [
					new ExpirationPlugin({
						maxEntries: 1500,
						maxAgeSeconds: 60 * 60 * 24 * 30, // 30 days
					}),
				],
			}),
		},
		{
			matcher: /\/_next\/data\/.*\.json/,
			handler: new StaleWhileRevalidate({
				cacheName: "next-data-cache",
				plugins: [
					new ExpirationPlugin({
						maxEntries: 100,
						maxAgeSeconds: 60 * 60 * 24, // 1 day
					}),
					new CacheableResponsePlugin({ statuses: [0, 200] }),
				],
			}),
		},
		{
			matcher: /\.(?:png|jpg|jpeg|svg|webp|woff2?)$/,
			handler: new CacheFirst({
				cacheName: "images",
				plugins: [
					new ExpirationPlugin({
						maxEntries: 60,
						maxAgeSeconds: 60 * 60 * 24 * 30, // 30 days
					}),
				],
			}),
		},
		{
			matcher: /\.(?:js|css)$/,
			handler: new StaleWhileRevalidate({
				cacheName: "static-resources",
			}),
		},
		// TRPC API
		{
			matcher: /^\/api\/trpc\/.*/,
			handler: new NetworkFirst({
				cacheName: "trpc-cache",
				networkTimeoutSeconds: 5,
				plugins: [
					new ExpirationPlugin({
						maxEntries: 100,
						maxAgeSeconds: 60 * 5, // 5 minutes
					}),
					new CacheableResponsePlugin({ statuses: [0, 200] }),
				],
			}),
		},
	],
});

serwist.addEventListeners();
